/**
 * Adds a :focus-within pseudoselector to a component with close-to-browser-default focus outline.
 *
 * Use when a custom component wraps a focusable input but doesn't display it: while the input is
 * focused, the component will show a focus outline.
 *
 * @param options: object with optional zIndex and outlineOffset integers
 * @returns {*}
 */
type FocusOutlineOptions = {
  zIndex?: number;
  outlineOffset?: number;
};
export default function FocusOutline(options: FocusOutlineOptions = {}): string {
  const defaults = {
    zIndex: 5,
    outlineOffset: -2,
  };
  const props = { ...defaults, ...options };
  return `
    &:focus-within {
      z-index: ${props.zIndex};
      // Mozilla
      outline: 5px auto Highlight;
      // WebKit
      outline: 5px auto -webkit-focus-ring-color;
      outline-offset: ${props.outlineOffset}px;
    }`;
}



// WEBPACK FOOTER //
// ../kibble/styles/FocusOutline.ts